// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { EntityList, Product } from "../flow/types";

export default function(
  state: EntityList<Product> = initialState.relatedProducts,
  action: any
) {
  switch (action.type) {
    case ActionTypes.GET_RELATED_PRODUCTS + ActionTypes.FULFILLED:
      var data = action.payload.data;
      const result: EntityList<Product> = new EntityList(data, 0);
      return result;
    default:
      return state;
  }
}
